import { Customer } from '@vote4dance/judging-schema';
import { StreamSource } from "../hooks/streams";

export type CustomerItem = Customer;

export const CustomerSource = new StreamSource<CustomerItem[]>("/customers");
